import { render, staticRenderFns } from "./CtaLibroLucia.vue?vue&type=template&id=95d8b6a4"
import script from "./CtaLibroLucia.vue?vue&type=script&lang=js"
export * from "./CtaLibroLucia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports